import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Urls from './Urls';

ReactDOM.render(
  <React.StrictMode>
    <Urls />
  </React.StrictMode>,
  document.getElementById('root')
);


